// React
import React from 'react';

// Mantine
import { useTranslation } from '@refinedev/core';
import {
  StatusFilterButtonItem,
  QuickStatusFilterButtons,
} from 'components/common';

// Enums
import { UploadStatusGroup, UploadStatusGroupCounts } from './uploadStatus';

interface UploadStatusQuickFiltersProps {
  activeGroup: UploadStatusGroup | null;
  onGroupChange: (group: UploadStatusGroup) => void;
  statusGroupCounts: UploadStatusGroupCounts;
}

const orderedGroups: UploadStatusGroup[] = [
  UploadStatusGroup.all,
  UploadStatusGroup.incomplete,
  UploadStatusGroup.complete,
];

export const UploadStatusQuickFilters: React.FC<UploadStatusQuickFiltersProps> = ({
  activeGroup,
  onGroupChange,
  statusGroupCounts,
}) => {
  const { translate } = useTranslation();

  const items: StatusFilterButtonItem<UploadStatusGroup>[] = orderedGroups.map(
    (group) => ({
      key: group,
      label: translate(`pages:uploads.quickFilters.${group}`, group),
      count: statusGroupCounts[group] ?? 0,
      active: activeGroup === group,
      dataTestId: `upload-status-filter-${group}`,
    })
  );

  return (
    <QuickStatusFilterButtons
      items={items}
      topKeys={orderedGroups}
      onSelect={onGroupChange}
    />
  );
};
